import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Modal } from "../../components/modal";
import { PersonForm, PersonFormValues } from "../../components/person-form";
import { useAdditionalFields } from "../../hooks/addition-fields";
import { parseFormValuesToAdditionalFields } from "../../services/additional-fields";
import { createPerson } from "../../services/person";
import { navigateBack } from "../../utils/navigate-back";

export function PersonCreate() {
  const navigate = useNavigate();
  const { data: additionalFields } = useAdditionalFields("person");
  const queryClient = useQueryClient();

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const [formValues, setFormValues] = useState<PersonFormValues>({
    personalIdentificationNumber: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    additionalFields: additionalFields.reduce(
      (acc, field) => ({
        ...acc,
        [field.name]: "",
      }),
      {},
    ),
  });

  const closeModal = () => {
    navigateBack(navigate, "/admin/register/person");
  };

  return (
    <Modal open onClose={() => closeModal()}>
      <PersonForm
        hasError={hasError}
        loading={loading}
        values={formValues}
        onCancel={() => closeModal()}
        onChange={setFormValues}
        onSubmit={() => {
          (async () => {
            setLoading(true);
            try {
              await createPerson({
                personalIdentificationNumber:
                  formValues.personalIdentificationNumber,
                firstName: formValues.firstName,
                lastName: formValues.lastName,
                email: formValues.email,
                phone: formValues.phone,
                ...(formValues.additionalFields && {
                  additionalData: parseFormValuesToAdditionalFields(
                    formValues.additionalFields,
                    additionalFields,
                  ),
                }),
              });
              await queryClient.invalidateQueries({
                queryKey: ["persons"],
              });
              closeModal();
            } catch (error: unknown) {
              setHasError(true);
            } finally {
              setLoading(false);
            }
          })();
        }}
      />
    </Modal>
  );
}
